import type { DepositAccount } from '@fruitful/types';
import {
    ArrowRightIcon,
    FruitfulCustomIcon,
    Icon,
    InstitutionLogo,
    Shadows,
    type StackProps,
    View,
    XStack,
} from 'smoothie';

import { FRUITFUL_INSTITUTION_NAME } from '../../types/BankAccount';

interface TransferAccountIconsProps {
    toAccount: DepositAccount;
    fromAccount: DepositAccount;
    containerStyle?: StackProps;
}

export const TransferAccountIcons = ({
    toAccount,
    fromAccount,
    containerStyle,
}: TransferAccountIconsProps) => {
    return (
        <XStack
            alignItems="center"
            justifyContent="center"
            marginVertical={24}
            {...containerStyle}
        >
            <TransferAccountIcon size="lg" account={fromAccount} />
            <View
                marginLeft={24}
                marginRight={24}
                alignSelf="flex-start"
                padding={6}
                marginTop={12}
                style={{ ...Shadows.SMALL }}
                zIndex={1}
            >
                <Icon icon={ArrowRightIcon} size={32} />
            </View>
            <TransferAccountIcon size="lg" account={toAccount} />
        </XStack>
    );
};

interface TransferAccountIconProps {
    account: DepositAccount;
    size: 'md' | 'lg';
    showShadow?: boolean;
}

export const TransferAccountIcon = ({
    account,
    size,
    showShadow = false,
}: TransferAccountIconProps) => {
    const { bankName, icon, color, logo } = account ?? {};

    return (
        <>
            {bankName === FRUITFUL_INSTITUTION_NAME ? (
                <FruitfulCustomIcon
                    icon={icon}
                    color={color}
                    size={size}
                    showShadow={showShadow}
                />
            ) : (
                <InstitutionLogo
                    logo={logo}
                    size={size}
                    showShadow={showShadow}
                />
            )}
        </>
    );
};
